// ======================================================================
// File Name       : ContentDrillSkinContainer.js
//
// Copyright(C) 2017 NIPPON TELEGRAPH AND TELEPHONE EAST CORPORATION All
// Rights Reserved.
//
// This source code or any portion thereof must not be
// reproduced or used in any manner whatsoever.
// ======================================================================

import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Col } from 'react-bootstrap';
import { searchSkin, downloadSkinFile, optionSkinInsert } from '../../actions/content/ContentDrillSkinAction';
import ContentDrillSkinSearch from '../../components/content/ContentDrillSkinSearch';
import ContentDrillSkinList from '../../components/content/ContentDrillSkinList';
import { RETURN_MAX_NUM } from '../../constants/index';
import { showLoading, hideLoading } from '../../utils/PageUtils';
import * as Path from '../../constants/PathConstants';
import Header from '../../components/Header';
import MessageSearch from '../../components/MessageSearch';
import * as actionType from '../../constants/actionTypes/page';
import DialogConfirm from '../../components/DialogConfirm';
import * as MessageTemplate from '../../constants/MessageTemplate';
import CustomLink from '../../components/button/CustomLink';
import PaginationCustom from '../../components/Pagination';

class ContentDrillSkinContainer extends Component {
  constructor() {
    super();
    this.state = {
      searchInfo: {
        skinSetSecernId: '',
        skinSetName: '',
        skinSortType: -1,
        ascendingDescendingSort: 0,
        startPosition: 0,
        returnMaxNum: RETURN_MAX_NUM,
      },
      recordNum: 0,
      skinList: [],
      isAllowShowSearchMessage: false,
      isInit: true,
      showModal: false, // #7080
    };

    this.handleInputChange = this.handleInputChange.bind(this);
    this.handleSearchBtn = this.handleSearchBtn.bind(this);
    this.getStartEndData = this.getStartEndData.bind(this);
    this.handleSortState = this.handleSortState.bind(this);
    this.handleDownloadSkinFile = this.handleDownloadSkinFile.bind(this);
    this.dismissMessage = this.dismissMessage.bind(this);
    // #7080 START
    this.handleOptionSkinInsert = this.handleOptionSkinInsert.bind(this);
    this.openInsertConfirmDialog = this.openInsertConfirmDialog.bind(this);
    this.onInsertCancel = this.onInsertCancel.bind(this);
    this.onInsertOk = this.onInsertOk.bind(this);
    // #7080 END
    this.handleMouseEnter = this.handleMouseEnter.bind(this);
    this.handleMouseLeave = this.handleMouseLeave.bind(this);
  }

  componentWillMount() {
    if (this.props.parentPath === Path.CONTENT_DRILL_SKIN_LIST) {
      this.setState({
        ...this.state,
        searchInfo: this.props.searchCondition,
        isInit: true,
      });
    }
  }

  componentDidMount() {
    this.getSkinList();
  }

  validateData() {
    return Object.keys(this.refsToValidate).every(
      ref => this.refsToValidate[ref].validation && this.refsToValidate[ref].validation(),
    );
  }

  /**
   * Get user list
   *
   */
  getSkinList() {
    const { dispatch } = this.props;
    const searchInfo = {
      skinSetSecernId: this.state.searchInfo.skinSetSecernId || undefined,
      skinSetName: this.state.searchInfo.skinSetName || undefined,
      skinSortType:
        this.state.searchInfo.skinSortType < 0 ? undefined : this.state.searchInfo.skinSortType,
      ascendingDescendingSort: this.state.searchInfo.ascendingDescendingSort,
      startPosition: this.state.searchInfo.startPosition,
      returnMaxNum: this.state.searchInfo.returnMaxNum,
    };
    dispatch(searchSkin(searchInfo)).then(() => {
      if (!this.state.isInit) {
        this.setState({ isAllowShowSearchMessage: true });
      }
    });
  }

  componentWillReceiveProps(nextProps) {
    const { skinListResult } = nextProps;
    if (!skinListResult) {
      return;
    }
    const { skinList, recordNum } = skinListResult;
    this.setState({
      skinList,
      recordNum,
    });
  }

  componentWillUnmount() {
    this.props.dispatch({
      type: actionType.SAVE_SEARCH_CONDITION,
      parentPath: Path.CONTENT_DRILL_SKIN_LIST,
      searchCondition: this.state.searchInfo,
    });
  }
  handleInputChange(event) {
    const { name, value } = event.target;
    const searchInfo = { ...this.state.searchInfo, ...{ [name]: value } };
    this.setState({
      searchInfo,
    });
  }

  /**
   * Handle search when click on search button
   *
   */
  handleSearchBtn() {
    const isValid = this.validateData();
    if (!isValid) {
      return;
    }
    const searchInfo = {
      ...this.state.searchInfo,
      startPosition: 0,
      isAllowShowSearchMessage: false,
    };
    this.setState(
      {
        searchInfo,
        isInit: false,
      },
      () => {
        this.getSkinList();
      },
    );
  }

  /**
   * Handle event when click on header of table, call API to sort data
   * @param row
   */
  handleSortState(row) {
    const isValid = this.validateData();
    if (!isValid) {
      return;
    }
    const { searchInfo } = this.state;
    searchInfo.ascendingDescendingSort = row.sortState;
    searchInfo.skinSortType = row.sortBy;
    this.setState(
      {
        searchInfo,
      },
      () => {
        this.getSkinList();
      },
    );
  }

  /**
   * Handle event when user change page on paging
   * @param startPosition
   */
  getStartEndData(startPosition) {
    const isValid = this.validateData();
    if (!isValid) {
      return;
    }
    this.setState(
      {
        searchInfo: { ...this.state.searchInfo, startPosition },
      },
      () => {
        this.getSkinList();
      },
    );
  }

  /**
   * Handle Download Skin File
   */
  handleDownloadSkinFile(id) {
    const param = {
      skinSetSecernId: id,
    };
    this.props.dispatch(showLoading());
    this.props.dispatch(downloadSkinFile(param));
  }

  dismissMessage() {
    this.setState({ isAllowShowSearchMessage: false });
  }

  // #7080 START
  openInsertConfirmDialog() {
    this.content = MessageTemplate.MSG_CONFIRM_INSERT_OPTION_SKIN;
    this.setState({ showModal: true });
  }

  onInsertCancel() {
    this.setState({ showModal: false });
  }

  onInsertOk() {
    this.setState({ showModal: false });
    this.handleOptionSkinInsert();
  }

  handleOptionSkinInsert() {
    const { dispatch } = this.props;

    dispatch(showLoading());
    dispatch(optionSkinInsert()).then(() => {
      this.handleSearchBtn();
      dispatch(hideLoading());
    });
  }

  handleMouseEnter(index) {
    this.setState({
      hoverIndex: index,
    });
  }

  handleMouseLeave() {
    this.setState({
      hoverIndex: undefined,
    });
  }
  // #7080 END

  render() {
    const { recordNum, skinList, isAllowShowSearchMessage, hoverIndex } = this.state;
    this.refsToValidate = [];
    return (
      <Col sm={12}>
        <MessageSearch
          recordNum={recordNum}
          resultList={skinList}
          isAllowShowSearchMessage={isAllowShowSearchMessage}
          dismissMessage={this.dismissMessage}
        />
        <CustomLink
          className="margin-right-7 url-list"
          to={Path.CONTENT_DRILL_LIST}
          text="ドリル管理に戻る"
          icon="bi bi-chevron-left"
        />
        <Header name="スキン情報の一覧" />
        <ContentDrillSkinSearch
          {...this.state.searchInfo}
          recordNum={recordNum}
          handleChange={this.handleInputChange}
          getStartEndData={this.getStartEndData}
          onSearchBtnClick={this.handleSearchBtn}
          onOptionSkinInsertClick={this.openInsertConfirmDialog}
          ref={(ref) => {
            if (ref) {
              this.refsToValidate.push(ref);
            }
          }}
        />
        <ContentDrillSkinList
          skinList={skinList}
          handleSortState={this.handleSortState}
          handleDownloadSkinFile={this.handleDownloadSkinFile}
          searchInfo={this.state.searchInfo}
          handleMouseEnter={this.handleMouseEnter}
          handleMouseLeave={this.handleMouseLeave}
          hoverIndex={hoverIndex}
        />
        <Col sm={12} className="d-flex justify-content-center">
          <PaginationCustom
            recordNum={recordNum}
            startPosition={this.state.searchInfo.startPosition}
            handlePageSelect={this.getStartEndData.bind(this)}
          />
        </Col>
        {/* #7080 START */}
        <DialogConfirm
          showModal={this.state.showModal}
          onCancel={this.onInsertCancel}
          content={this.content}
          onOK={this.onInsertOk}
        />
        {/* #7080 END */}
      </Col>
    );
  }
}

const mapStateToProps = (state, ownProps) => {
  const { parentPath, searchCondition } = state.page;
  return {
    ...{ skinListResult: state.content.skinListResult },
    parentPath,
    searchCondition,
  };
};

export default connect(mapStateToProps)(ContentDrillSkinContainer);
